<script lang="ts">
  import type { EventGroup, Explore } from "../interfaces/explore";
  import InnerHtml from "./inner-html.svelte";
  import Expander from "./expander.svelte";
  import Event from "./event.svelte";

  export let explore: Explore | null;
  export let eventGroup: EventGroup | null = null;
  let eventObjectMaps: any[] = [];
  let isGeneralEventExpanded = false;

  const createdObjectMap = (eventName: string, objectMap: any) => {
    eventObjectMaps = [ ...eventObjectMaps, { name: eventName, objectMap: objectMap }];
  };

  const expandEvent = () => {
    isGeneralEventExpanded = !isGeneralEventExpanded;
  };
</script>

<div class="heading mb-24 pt-24">
  <h1>pixx.io API</h1>
</div>

<div class="legalInformation">
  <span class="mb-24">
    <a href="https://www.pixx.io/en/data-privacy-statement" target="_blank" rel="noopener noreferrer">
      Data privacy statement
    </a>
    &middot;
    <a href="https://www.pixx.io/en/imprint" target="_blank" rel="noopener noreferrer">
      Legal notice
    </a>
  </span>
</div>

{#if explore}
  <div class="subHeadline mt-24 mb-24 pt-24"><InnerHtml htmlType="span" text={explore.description} /></div>
{/if}

{#if eventGroup?.generalEventObject}
  <div class="appHeader__item">
    <div class="header">
      <h2>General Event</h2>
      <h3>
        Whenever an event gets triggered, it always contains the following properties.<br>
        Additional data may be added depending on the event. You can find these informations in most group headers under <span>EVENTS</span>.
      </h3>
      <div class="header__infoSection">
        <Expander isExpanded={isGeneralEventExpanded} expand={expandEvent}/>
        {#if isGeneralEventExpanded}
          <div class="events">
            <Event
              eventObject={eventGroup.generalEventObject}
              {eventObjectMaps}
              {createdObjectMap}
            />
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  .heading,
  .legalInformation {
    display: flex;
    user-select: none;
  }

  .heading {
    flex-direction: column;
    margin-top: 50px;
  }

  h1 {
    font-size: 36px;
    font-weight: 600;
  }

  .legalInformation {
    font-size: 12px;

    > span {
      width: 100%;
    }
  }

  .appHeader__item {
    padding-bottom: 64px;

    .header {
      h3 > span {
        color: var(--hint-400);
      }
    }
  }
</style>
